import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppUploadpaketeMainComponent} from '../../app.uploadpakete.main';

@Component({
  selector: 'app-side-scrolling',
  templateUrl: './side-scrolling.component.html',
  styleUrls: ['./side-scrolling.component.scss']
})
export class SideScrollingComponent implements OnInit {

  numberOfPages: number;

  @Input()
  maxLengthOfDisplayed: number;

  @Output()
  notifyCurrentSite: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  notifyDisplayedSites: EventEmitter<number> = new EventEmitter<number>();
  displayedSites: number = 10;
  hitsPerSiteArray: number[] = [10, 25, 100];
  currentSite: number = 0;
  leftSideOfDisplayedPageSelectors: number = 0;
  sitesArray: number [];

  ngOnInit() {
    this.calculateNumberOfPages();
    this.goToFirstPage();
    this.fillNumberArrayOfPages();
  }

  rangeOfDisplayedPages(): number {
    if (this.numberOfPages > 5) {
      return 3;
    } else {
      return 5;
    }
  }

  isCurrentPage(site: number): boolean {
    return this.currentSite == site;
  }

  incrementPageRange() {
    let maxLength = this.numberOfPages;
    maxLength = SideScrollingComponent.minusWithLowestResultZero(maxLength, this.rangeOfDisplayedPages());
    this.leftSideOfDisplayedPageSelectors = SideScrollingComponent.incrementSite(this.leftSideOfDisplayedPageSelectors, maxLength);
  }

  decrementPageRange() {
    this.leftSideOfDisplayedPageSelectors = SideScrollingComponent.decrementSite(this.leftSideOfDisplayedPageSelectors);
  }

  changePage(site: number) {
    if (this.leftSideOfDisplayedPageSelectors == site) {
      this.decrementPageRange();
    } else {
      this.incrementPageRange();
    }
    this.currentSite = site;
    this.notifyCurrentSite.emit(site);
  }

  goToFirstPage() {
    this.leftSideOfDisplayedPageSelectors = 0;
    this.changePage(0);
  }

  changeNumberDisplayedElements(hits: number) {
    this.displayedSites = hits;
    this.notifyDisplayedSites.emit(hits);
    this.calculateNumberOfPages();
    this.fillNumberArrayOfPages();
    this.goToFirstPage();
  }

  giveSiteRangeString(site: number): string {
    const rightBorder: number = site + 1 == this.numberOfPages ? this.maxLengthOfDisplayed : (site + 1) * this.displayedSites;
    return site * this.displayedSites + 1 + "-" + rightBorder;
  }

  private fillNumberArrayOfPages() {
    this.calculateNumberArrayWithPages(this.numberOfPages);
  }

  private calculateNumberArrayWithPages(numberOfPages: number) {
    this.sitesArray = AppUploadpaketeMainComponent.calculateNumberArray(numberOfPages);
  }

  private calculateNumberOfPages() {
    this.numberOfPages = Math.ceil(this.maxLengthOfDisplayed / this.displayedSites);
  }

  private static minusWithLowestResultZero(left: number, right: number): number {
    const tmpValue = left - right;
    return tmpValue < 0 ? 0 : tmpValue;
  }

  private static incrementSite(page: number, maxLength: number): number {
    return page >= maxLength ? maxLength : page + 1;
  }

  private static decrementSite(page: number): number {
    return page < 1 ? 0 : page - 1;
  }
}
